import { useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import { Box, Button,} from '@mui/material'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import moment from 'moment'
import { RefreshSvg } from '../../common/svg/refresh'
import { SplitButton } from '../../common/SplitButton'
import { AcountingHeading } from './common/AcountingHeading'
import { bookingType, gstPaidBy } from '././common/AcountingConstants'
import { paymentModesWithAll } from '../../common/paymentsMode'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../common/helper'
import { getgstReportDetailData, getgstReportFilterData, getgstReportSummaryData } from '../../../store/reports/reports_action'
import { useEffect } from 'react'
import { updateAlertError, updateModal } from '../../../store/common/common_action'
import { GSTReportv1FilterHeaders, GSTReportv1Headers } from './contants'
import { urls } from '../../common/constants'
// import { TableComponent } from '../../common/TableComponent'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { GetRequest } from '../../common/api'
const GSTReportV1 = (props) => {
  const {
    data: { common, reports },
    getgstReportFilterData,
  } = props
  const setAlert = useSetAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const { gstReportFilterData } = reports
  const { loginData, roleRights } = common
  const reportName = 'GST V1'
  const viewReport = [
    { id: 0, name: 'Detailed' },
  ]
  const [stateList, setStateList] = useState([])
  const [sourceCityList, setSourceCityList] = useState([])
  const [filterSourceCityList, setFilterSourceCityList] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [filterSourceBranchList, setFilterSourceBranchList] = useState([])
  const [destCityList, setDestCityList] = useState([])
  const [destBranchList, setDestBranchList] = useState([])
  const [filterDestBranchList, setFilterDestBranchList] = useState([])
  const [selState, setSelState] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState([])
  const [selDestCity, setSelDestCity] = useState([])
  const [selDestBranch, setSelDestBranch] = useState([])
  const [selPayment, setSelPayment] = useState(paymentModesWithAll?.[0])
  const [selGstPaidBy, setSelGstPaidBy] = useState(gstPaidBy[0])
  const [selReportView, setselReportView] = useState(viewReport[0])
  const [selBookingType, setselBookingType] = useState(bookingType[0])
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [isExpanded, setIsExpanded] = useState(false)
  const [tableData, setTableData] = useState([])
  const [resetFlag, setResetFlag] = useState(false)
  const [resetBranch, setResetBranch] = useState(false)
  const [resetBranch1, setResetBranch1] = useState(false)
  const [resetCity, setResetCity] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)

  const headers = GSTReportv1Headers.map((col) => ({
    ...col,
    align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
    exportHead: col.header,
  }))

  useEffect(() => {
    focusElemnt(id.gstFromDate)
  }, [])
  useEffect(() => {
    if (!isEmpty(roleRights)) {
      setDisableExcel(!roleRights?.Table1?.[0]?.AllowExportExcel)
    }
  }, [roleRights])
  useEffect(() => {
    if (!isEmpty(gstReportFilterData)) {
      if (gstReportFilterData?.Data?.Table?.length > 0) {
        let data = []
        let data1 = []
        let data2 = []
        let data3 = []
        let data4 = []
        gstReportFilterData?.Data?.Table?.map((val, i) => {
          data.push({ StateID: val?.StateID, Statename: val?.Statename })
          data1.push({ SourceCityID: val?.SourceCityID, SourceCity: val?.SourceCity, StateID: val?.StateID })
          data2.push({ SourceBranchID: val?.SourceBranchID, SourceBranch: val?.SourceBranch, SourceCityID: val?.SourceCityID })
          data3.push({ DestinationCityID: val?.DestinationCityID, DestinationCity: val?.DestinationCity })
          data4.push({
            DestinationBranchID: val?.DestinationBranchID,
            DestinationBranch: val?.DestinationBranch,
            DestinationCityID: val?.DestinationCityID,
          })
        })
        setStateList([{ Statename: 'All', StateID: 0 }, ...data])
        setSourceCityList([{ SourceCity: 'All', SourceCityID: 0 }, ...data1])
        //filter cityList for city
        setFilterSourceCityList([{ SourceCity: 'All', SourceCityID: 0 }, ...data1])
        setSourceBranchList([{ SourceBranch: 'All', SourceBranchID: 0 }, ...data2])
        //filter branchList for branch
        setFilterSourceBranchList([{ SourceBranch: 'All', SourceBranchID: 0 }, ...data2])
        setDestCityList([{ DestinationCity: 'All', DestinationCityID: 0 }, ...data3])
        setDestBranchList([{ DestinationBranch: 'All', DestinationBranchID: 0 }, ...data4])
        setFilterDestBranchList([{ DestinationBranch: 'All', DestinationBranchID: 0 }, ...data4])
        //deafultValue
        setSelState({
          Statename: gstReportFilterData?.Data?.Table?.filter((obj) => obj.SourceCityID === loginData?.intBranchCityID)[0]?.Statename,
          StateID: gstReportFilterData?.Data?.Table?.filter((obj) => obj.SourceCityID === loginData?.intBranchCityID)[0]?.StateID,
        })
        setSelSourceCity({ SourceCity: loginData?.strCityName, SourceCityID: loginData?.intBranchCityID })
        setSelSourceBranch({ SourceBranch: loginData?.strBranchName, SourceBranchID: loginData?.intBranchID })
        setSelDestCity({ DestinationCity: 'All', DestinationCityID: 0 })
        setSelDestBranch({ DestinationBranch: 'All', DestinationBranchID: 0 })
      } else {
        setStateList([])
        setSourceCityList([])
        setSourceBranchList([])
        setDestCityList([])
        setDestBranchList([])
        setSelState('')
        setSelSourceCity('')
        setSelSourceBranch('')
        setSelDestCity('')
        setSelDestBranch('')
      }
    }
  }, [gstReportFilterData])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
      //setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
    }
  }, [roleRights, loginData])
  const handleClick1 = () => {
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    const isAllSelected = selSourceCity.SourceCityID === 0 || selSourceBranch.SourceBranchID === 0 || selDestCity.DestinationCityID === 0 || selDestBranch.DestinationBranchID === 0
    if (isAllSelected && diffDays > 15) {
      setAlert({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
      return
    } else if (!isAllSelected && diffDays > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    }
    setLoader(true)
    const data = {
      CompanyID: loginData.intCompanyID,
      FromDate: fromDate.format('YYYY-MM-DD'),
      ToDate: toDate.format('YYYY-MM-DD'),
      StateID: selState.StateID,
      SourceCityID: selSourceCity.SourceCityID,
      SourceBranchID: selSourceBranch.SourceBranchID,
      DestCityID: selDestCity.DestinationCityID,
      DestBranchID: selDestBranch.DestinationBranchID,
      PaymentType: selPayment.typeId,
      GSTPaidBy: selGstPaidBy.value,
      GstType: selBookingType.id,
    }
    GetRequest(urls.getGSTReportData, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        const data=res?.Data?.Table.map((item, index)=>({...item,SN:index+1,dataType: 'entry',}))
        const reportPayload = {
          reportName:reportName+' Report',
          criteriaHeaders: GSTReportv1FilterHeaders,
          criteriaData: [filterData],
          tableData: data,
          mainHeader: headers,
        }

        const rid = Date.now().toString()

        if (!window.generatedReports) {
          window.generatedReports = {}
        }

        window.generatedReports[rid] = reportPayload

        window.open(`/view-report?rid=${rid}`, "_blank")
        // setTableData(data)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const handleGoClick = () => {
    // if (diffInMonths(fromDate, toDate) !== 0) {
    //   handleAlert('Selected Date Range Should Be One Month Or Less Than It!')
    // } else {
    const obj = {
      CompanyID: loginData?.intCompanyID,
      FromDate: fromDate.format('YYYY-MM-DD'),
      ToDate: toDate.format('YYYY-MM-DD'),
    }
    getgstReportFilterData(obj)
    focusElemnt(disableBtn ? id.destCity : id.stateId)
    // }
  }
  const handleCityChange = (cityId, type) => {
    if (type === 'SourceCity') {
      if (cityId !== 0) {
        setResetBranch(true)
        const filteredBranches = sourceBranchList.filter((branch) => branch.SourceCityID === cityId)
        const branchListWithAll = [{ SourceBranch: 'All', SourceBranchID: 0 }, ...filteredBranches];
        setFilterSourceBranchList(branchListWithAll)
        setSelSourceBranch({ SourceBranch: 'All', SourceBranchID: 0 })
      } else {
        setFilterSourceBranchList([{ SourceBranch: 'All', SourceBranchID: 0 }, ...sourceBranchList])
        setSelSourceBranch(sourceBranchList[0])
      }
    } else {
      if (cityId !== 0) {
        setResetBranch1(true)
        const filteredBranches = destBranchList.filter((branch) => branch.DestinationCityID === cityId)
        setFilterDestBranchList([{ DestinationBranch: 'All', DestinationBranchID: 0 }, ...filteredBranches])
      } else {
        setFilterDestBranchList([{ DestinationBranch: 'All', DestinationBranchID: 0 }, ...destBranchList])
      }
    }
  }
  const handleStateChange = (stateId) => {
    if (stateId !== 0) {
      setResetCity(true)
      const filteredCities = sourceCityList.filter((branch) => branch.StateID === stateId)
      setFilterSourceCityList([{ SourceCity: 'All', SourceCityID: 0 }, ...filteredCities])
    } else {
      setFilterSourceCityList([{ SourceCity: 'All', SourceCityID: 0 }, ...sourceCityList])
    }
  }
  const filterData = {
    fromDate: moment(fromDate).format('DD-MM-YYYY'),
    toDate: moment(toDate).format('DD-MM-YYYY'),
    stateName: selState?.Statename,
    sourceCity: selSourceCity?.SourceCity,
    sourceBranch: selSourceBranch?.SourceBranch,
    destCity: selDestCity?.DestinationCity,
    destBranch: selDestBranch?.DestinationBranch,
    paymentType: selPayment?.name,
    gstPaidBy: selGstPaidBy?.name,
    bookingType: selBookingType?.value,
    dataType: 'entry',
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <AcountingHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectCompany}
              label={lb.select_company}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              minWidth="250px"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={`From Booking Date`}
              name={'from_date'}
              id={id.gstFromDate}
              value={fromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
              width="210px"
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Booking Date'}
              name={'to_date'}
              id={id.toDate}
              value={toDate}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt('goButton')
              }}
              width="210px"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              id={'goButton'}
              variant="contained"
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
              onClick={handleGoClick}
              onKeyDown={(e) => navigation3(e, disableBtn ? id.destCity : id.stateId, id.toDate, handleGoClick)}
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.stateId}
              label={'Select State'}
              data={removeDuplicatesFromArray(stateList, 'StateID') || []}
              defaultvalue={selState?.Statename}
              idKey={`StateID`}
              dataKey={`Statename`}
              onSelect={(val) => {
                setSelState(val)
                setIsExpanded(false)
                handleStateChange(val.StateID)
              }}
              isObjArr={true}
              //searchPlaceholder={`Search By Report Type`}
              width="160px"
              nextId={id.srcCity}
              prevId={'goButton'}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcCity}
              label={'Source City'}
              data={removeDuplicatesFromArray(filterSourceCityList, 'SourceCityID') || []}
              defaultvalue={selSourceCity?.SourceCity}
              idKey={`SourceCityID`}
              dataKey={`SourceCity`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelSourceCity(val)
                handleCityChange(val.SourceCityID, 'SourceCity')
                setResetCity(false)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="160px"
              nextId={id.srcBranch}
              prevId={id.stateId}
              resetFlag={resetCity || resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcBranch}
              label={'Source Branch'}
              data={removeDuplicatesFromArray(filterSourceBranchList, 'SourceBranchID') || []}
              defaultvalue={selSourceBranch?.SourceBranch}
              idKey={`SourceBranchID`}
              dataKey={`SourceBranch`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelSourceBranch(val)
                setResetBranch(false)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="250px"
              nextId={id.destCity}
              prevId={id.srcCity}
              resetFlag={resetBranch || resetFlag}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.destCity}
              label={'Destination City'}
              data={removeDuplicatesFromArray(destCityList, 'DestinationCityID') || []}
              defaultvalue={selDestCity?.DestinationCity}
              idKey={`DestinationCityID`}
              dataKey={`DestinationCity`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelDestCity(val)
                handleCityChange(val.DestinationCityID, 'DestinationCity')
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="160px"
              nextId={id.destBranch}
              prevId={disableBtn ? 'goButton' : id.srcBranch}
              resetFlag={resetFlag}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.destBranch}
              label={'Destination Branch'}
              data={removeDuplicatesFromArray(filterDestBranchList, 'DestinationBranchID') || []}
              defaultvalue={selDestBranch?.DestinationBranch}
              idKey={`DestinationBranchID`}
              dataKey={`DestinationBranch`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelDestBranch(val)
                setResetBranch1(false)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="250px"
              nextId={id.payType}
              prevId={id.destCity}
              resetFlag={resetBranch1 || resetFlag}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.payType}
              label={'Payment Type'}
              data={paymentModesWithAll || []}
              defaultvalue={selPayment?.name}
              idKey={`typeId`}
              dataKey={`name`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelPayment(val)
              }}
              isObjArr={true}
              //searchPlaceholder={`Search By Report Type`}
              width="160px"
              nextId={id.gstPaidBy}
              prevId={id.destBranch}
              resetFlag={resetFlag}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.gstPaidBy}
              label={'GST Paid By'}
              data={gstPaidBy || []}
              defaultvalue={selGstPaidBy?.name}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelGstPaidBy(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="160px"
              nextId={id.bookingType}
              prevId={id.payType}
              resetFlag={resetFlag}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.bookingType}
              label={'Booking Type'}
              data={bookingType}
              defaultvalue={bookingType[0]?.name}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setIsExpanded(false)
                setselBookingType(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="200px"
              nextId={id.reportView}
              prevId={id.gstPaidBy}
              resetFlag={resetFlag}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.reportView}
              label={lb.reportView}
              data={viewReport}
              defaultvalue={viewReport[0].name}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setIsExpanded(false)
                setselReportView(val)
              }}
              disabled={true}
              isObjArr={true}
              searchPlaceholder={`Search Report`}
              width="120px"
              nextId={id.gstSplitButton}
              prevId={id.bookingType}
              resetFlag={resetFlag}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            onKeyDown={(e) =>
              navigation3(
                e,
                isExpanded ? (disableExcel ? 'gstExportAsPdfBtn' : 'gstExportToExlbtn') : id.gstFromDate,
                // id.anReportOptions,
                () => handleClick1()
              )
            }
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              //hideToggle={false}
              prevID={id.reportView}
              id1={id.gstSplitButton}
              onClick1={handleClick1}
            // onClick2={handleClick2}
            />
          </Item>
          <Item
            sx={{ ...sx.itemsx }}
            onClick={() => {
              setResetFlag(!resetFlag)
            }}
          >
            <RefreshSvg />
          </Item>
        </Box>
      </Item>
      {/* <Item>
        {isExpanded ? (
          selReportView?.id ? (
            <DetailedTable
              tableData={tableData}
              tableDataForGST={tableDataGST}
              tableDataForNonGST={tableDataNonGST}
              loginData={loginData}
              fromDate={fromDate}
              toDate={toDate}
              stateName={selState.Statename}
              sourceCity={selSourceCity.SourceCity}
              sourceBranch={selSourceBranch.SourceBranch}
              destCity={selDestCity.DestinationCity}
              destBranch={selDestBranch.DestinationBranch}
              paymentType={selPayment.name}
              gstPaidBy={selGstPaidBy.name}
              bookingType={selBookingType}
              // updateScreen={handleClick1}
              updateModal={updateModal}
              columns={manageColumn}
              selectedFields={selectedFields}
              disableExcel={disableExcel}
              UseFormattedLRinReports={UseFormattedLRinReports}
            />
          ) : (
            <SummaryTable
              tableData={tableData}
              loginData={loginData}
              fromDate={fromDate}
              toDate={toDate}
              stateName={selState.Statename}
              sourceCity={selSourceCity.SourceCity}
              sourceBranch={selSourceBranch.SourceBranch}
              destCity={selDestCity.DestinationCity}
              destBranch={selDestBranch.DestinationBranch}
              paymentType={selPayment.name}
              gstPaidBy={selGstPaidBy.name}
              bookingType={selBookingType.name}
              disableExcel={disableExcel}
            ></SummaryTable>
          )
        ) : (
          ''
        )}
      </Item> */}
      {/* {tableData.length ? (
        <TableComponent
          reportName={reportName}
          criteriaHeaders={GSTReportv1FilterHeaders}
          criteriaData={[filterData]}
          tableData={tableData}
          mainHeader={headers}
        />
      ) : null} */}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getgstReportFilterData,
  getgstReportDetailData,
  getgstReportSummaryData,
  updateAlertError,
  updateModal,
}
export default connect(mapStateToProps, mapDispatchToProps)(GSTReportV1)
